import { render } from "./Step3.vue?vue&type=template&id=46e3d05a&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"

import "./Step3.vue?vue&type=style&index=0&id=46e3d05a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e3d05a"]])

export default __exports__